import React, { useState, useEffect } from 'react'
import { InputItem } from 'antd-mobile';

export const InputBox = (props) => {
  const [textValue, setTextValue] = useState(null);

  useEffect(() => {
    setTextValue([props.value]);
  }, [props.value])

  return (
    <>
      <div style={{ borderBottomStyle: 'groove', color: '#978897', fontSize: '14px', fontVariant: 'tabular-nums', marginTop: '-11px' }}>
        <InputItem
          value={textValue}
          type={props.type ?? 'text'}
          disabled={props.disabled ?? false}
          clear
          placeholder={props.placeholder}
          onChange={(value) => {
            setTextValue(value);
            if (props.onChange) {
              props.onChange(value);
            }
          }}
        >{props.label}</InputItem>
      </div>
    </>
  )
}
